import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ConnectionService } from './connection.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  users = [];

  constructor(private connectionService: ConnectionService, public http: HttpClient) { }

  public getUsers() {
    $(".overlay-loading").show();
    let url = 'get-all-users' + '?size=200&page=0&sort-by=billOfLadingId&order-by=asc';
    this.connectionService.getUserList(url).subscribe(data => {
      $(".overlay-loading").hide();
      this.users = data;
    });
  }

  saveLoadDetailsMultiple(load: any): Observable<any> {
    let url = "save-csvload-dashboard";

    let headers = {
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'scac':  JSON.parse(localStorage.getItem("user-tenant")) ? JSON.parse(localStorage.getItem("user-tenant")).scac : "prod",
      'request-source': 'WEB',
      'Content-Type': 'application/json'
    };
    
    return this.http.post(environment.apiURL+ url, load, {headers: headers});
  }

  saveLoadDetailsTD(load: any): Observable<any> {
    let url = "save-TD-dashboard";
    let headers = {
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'scac':  JSON.parse(localStorage.getItem("user-tenant")) ? JSON.parse(localStorage.getItem("user-tenant")).scac : "prod",
      'request-source': 'WEB',
      'Content-Type': 'application/json'
    };
    
    return this.http.post(environment.apiURL+ url, load, {headers: headers});
  }

  allowBolEdit(){
    let url = "allow-edit-from-portal";

    let headers = {
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'scac':  JSON.parse(localStorage.getItem("user-tenant")) ? JSON.parse(localStorage.getItem("user-tenant")).scac : "prod",
      'request-source': 'WEB',
      'Content-Type': 'application/json'
    };
    
    return this.http.get(environment.apiURL+ url, {headers: headers});
  }

  fetchDealerNotes(bolId, tenantScac){
    let url = "fetch-bol-notes";
    let headers = {
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'scac':  JSON.parse(localStorage.getItem("user-tenant")) ? JSON.parse(localStorage.getItem("user-tenant")).scac : "prod",
      'request-source': 'WEB',
      'Content-Type': 'application/json',
      'bol-id': bolId+"",
      'tenant-scac': tenantScac
    };
    return this.http.get(environment.apiURL+ url, {headers: headers});
  }

  saveBolNote(load: any): Observable<any>{
    let url = "save-bill-of-lading-notes";
    let headers = {
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'scac':  JSON.parse(localStorage.getItem("user-tenant")) ? JSON.parse(localStorage.getItem("user-tenant")).scac : "prod",
      'request-source': 'WEB',
      'Content-Type': 'application/json'
    };
    return this.http.post(environment.apiURL+ url, load, {headers: headers});
  }

}
